import BaseApi from "../baseApi";

interface IProductAPI {
    getProducts: (carId: number, vin: string, debitorNo: string) => Promise<ProductGroup[]>;
    searchForMultipleProducts: (search: string) => Promise<ProductGroup[]>;
    getProduct: (search: string) => Promise<Product>;
    getRep: () => Promise<ProductGroup[]>;
    autoComplete: (searchTerm: string) => Promise<string[]>;
    getInstuctionUrl: (euroCode:string) => Promise<string | undefined>;
}

export default class ProductAPI extends BaseApi implements IProductAPI {
    async getInstuctionUrl(euroCode: string) : Promise<string | undefined>
    {
        const url = `/api/Instruction/${euroCode}`;
        return await this.fetchGet(url);
    }
    async searchForMultipleProducts(search: string): Promise<ProductGroup[]> {
        const url = `/api/product/searchitems?search=${encodeURIComponent(
            search
        )}`;
        return await this.fetchGet(url);
    }

    async search(
        searchTerm: string,
        debitorNo?: string,
        signal?: AbortSignal,
        excludePrice?: boolean
    ): Promise<ProductGroup[]> {
        let url = `/api/product/search/?term=${encodeURIComponent(
            searchTerm
        )}&debitorNo=${debitorNo}`;
        if(excludePrice)
        {
            url = url.concat(`&excludePrice=${excludePrice}`);
        }
        return await this.fetchGet(url, signal);
    }

    async searchForGludPads(
        terms: string[],
        debitorNo?: string,
        signal?: AbortSignal
    ): Promise<ProductGroup[]> {
        const url = `/api/product/SearchForGluePads?debitorNo=${debitorNo}`;
        return await this.fetchPost(url, terms, signal);
    }

    async vinSearch(
        vinNumber: string,
        debitorNo: string,
        signal?: AbortSignal
    ): Promise<ProductGroup[]> {
        const url = `/api/product/vinsearch/${vinNumber}?debitorNo=${debitorNo}`;
        return await this.fetchGet(url, signal);
    }

    async getProduct(search: string): Promise<Product> {
        const url = `/api/product/searchitem?search=${encodeURIComponent(
            search
        )}`;
        return await this.fetchGet(url);
    }

    async autoComplete(
        searchTerm: string,
        debitorNo?: string
    ): Promise<string[]> {
        const url = `/api/product/autoComplete?term=${encodeURIComponent(
            searchTerm
        )}&debitorNo=${debitorNo}`;
        return await this.fetchGet(url);
    }

    async getProducts(
        carId: number,
        vin: string,
        debitorNo: string,
        signal?: AbortSignal
    ): Promise<ProductGroup[]> {
        const url = `/api/product/cardata/${carId}?vin=${vin}&debitorNo=${debitorNo}`;
        return await this.fetchGet(url, signal);
    }

    async getRep(signal?: AbortSignal): Promise<ProductGroup[]> {
        const url = `/api/product/carrep`;
        return await this.fetchGet(url, signal);
    }
}
